var cov_19gw1xrcer = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Carousel/styles/index.ts",
      hash = "352e9fb395007a1ff80e5b0c0620d75327abef56",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Carousel/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var carouselLess = {};
import genaration from '../../utils/classname';
export var carouselClass = (cov_19gw1xrcer.s[0]++, genaration(carouselLess, 'carousel'));